module.exports = __webpack_public_path__ + "img/右通风.b043eaa2.png";